export const s3Mixin = {
  methods: {
    s3_openFile(bucket, data) {
      let fileKey = bucket + '/' + data.fileName
      let url = this.composeS3Url(fileKey)
      window.open(url)
    },
    composeS3Url(fileKey) {
      return 'https://chaffis.s3-eu-west-1.amazonaws.com/' + fileKey
    }
  }
}
